import React from 'react';
import {ThemeProvider} from '../../../ui-library';
import {Title, PageBox, TitlesBox, BackBox, BackIcon, BackBtn} from '../Style/CreateAutoProject.style';
import useCreateAutoClassificationProject from '../Controllers/CreateAutoProject.controller';
import {ReferenceImageUpload} from '../../../Containers Components/ReferenceImageUpload';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import AutoProjectMetaDataView from '../../../Containers Components/AutoProjectMetaData/View/AutoProjectMetaData.view';
import CreateAutoProjectButtonsView from '../../../Containers Components/CreateAutoProjectButtons';
import {ClassList} from '../../../Containers Components/ClassList';
import BeforeExitModalView from '../../../Containers Components/BeforeExitModal/View/BeforeExitModal.view';

const CreateAutoProjectView = () => {
    const {autoProjectState, navigateToDataProjects, initialNewAutoProject, runAutoClassifier, setState, editDraftAutoProject, onDoneProcess, uiFileList, numberOfFiles, uploadCounter, uploadImages, onDeleteFile, uiFiledFileList, retryAllFiledFiles, deleteClass, navigateToAutoStatusPage, openExitModal, setOpenExitModal, closeModal} = useCreateAutoClassificationProject();

    return (
        <ThemeProvider>
            <PageBox id='create-auto-project-page'>
                <TitlesBox id='create-auto-project-title-box'>
                    <BackBox onClick={() => setOpenExitModal(true)} id='create-auto-project-back-btn-box'>
                        <BackBtn startIcon={<BackIcon id='create-auto-project-back-icon'/>} id='create-auto-project-back-btn' size='small' > Back to projects</BackBtn>
                    </BackBox>
                    <Title id='create-auto-project-title'> {_SYSTEM_TITLES.createNewAutoProjectTitle} </Title>
                </TitlesBox>
                <AutoProjectMetaDataView
                    autoProjectState={autoProjectState}
                    setState={setState}
                    initialNewAutoProject={initialNewAutoProject}
                />
                <ReferenceImageUpload
                    isGlobalError={true}
                    isCanAddFile={autoProjectState.activeEditId === -1}
                    deleteClass={deleteClass}
                    globalError={autoProjectState.activeEditId === -1 ? autoProjectState.classError : ''}
                    retryAllFiledFiles={retryAllFiledFiles}
                    numberOfFiles={numberOfFiles}
                    uploadCounter={uploadCounter}
                    uiFileList={autoProjectState.activeEditId === -1 ? uiFileList : []}
                    uiFiledFileList={uiFiledFileList}
                    onDoneProcess={onDoneProcess}
                    initValue={autoProjectState.activeEditId === -1 && autoProjectState.className}
                    autoProjectState={autoProjectState}
                    onDeleteFile={onDeleteFile}
                    getChosenFiles={(files) => autoProjectState.activeEditId === -1 && uploadImages(files)}
                    setState={setState}
                    closeModal={closeModal}
                    data_project_id={autoProjectState.projectId}
                />
                <ClassList
                    deleteClass={deleteClass}
                    retryAllFiledFiles={retryAllFiledFiles}
                    uploadCounter={uploadCounter}
                    numberOfUploadFiles={numberOfFiles}
                    uiFiledFileList={uiFiledFileList}
                    onDeleteFile={onDeleteFile}
                    uiFileList={uiFileList}
                    getChosenFiles={(files) => uploadImages(files)}
                    autoProjectState={autoProjectState}
                    setState={setState}
                    onDoneProcess={onDoneProcess}
                />
                <CreateAutoProjectButtonsView
                    autoProjectState={autoProjectState}
                    editDraftAutoProject={editDraftAutoProject}
                    initialNewAutoProject={initialNewAutoProject}
                    setState={setState}
                    navigateToDataProjects={navigateToDataProjects}
                    runAutoClassifier={runAutoClassifier}
                    navigateToAutoStatusPage={navigateToAutoStatusPage}
                />
                <BeforeExitModalView
                    title={_SYSTEM_TITLES.autoProjectExitModalTitle}
                    content={_SYSTEM_TITLES.autoProjectExitModalContent}
                    yesTitle={_SYSTEM_TITLES.autoProjectExitModalStayBtn}
                    cancelTitle={_SYSTEM_TITLES.autoProjectExitModalBackBtn}
                    open={openExitModal}
                    setOpen={setOpenExitModal}
                    onClick={navigateToDataProjects}/>
            </PageBox>
        </ThemeProvider>
    );
};

export default CreateAutoProjectView;
